const recipe_4_5 = { width: 400, height: 500 }
const locationCard_5_4 = { width: 640, height: 512 }
const reportCard_4_5 = { transform:"fit", width: 500, height: 707 }
export { recipe_4_5, locationCard_5_4, reportCard_4_5 }